import { ChangeDetectorRef, Component, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  CodeConversionMstDto, Sgke401aRequest, Sgke404aRequest,
  Sgke404aRequestLossInfoList, Sgke404aRequestLossyoteiChargeKeylst, Sgke411aRequest,
  Sgke411aResponseLossyoteiChargeKeylst, Sgke411aResponseSearchresultList, Sgke412aRequest,
  Sgke412aRequestLossyoteiChargeInformationlist, Sgke412aRequestLossyoteiChargeKeylst, Sgke903aRequest,
  Sgke903aResponseCompanyAreaInfo, Sgke903aResponseInitialhyojiInfo
} from "sg-api";
import { SgAriaMessage } from '../../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { CodeConversionMstService } from '../../../../../../sg-base/sg-base-shared/services/codeConversionMst.service';
import { UsedSgke401aService } from '../../../../../sg-ke-shared/services/used-sgke401a.service';
import { UsedSgke404aService } from '../../../../../sg-ke-shared/services/used-sgke404a.service';
import { UsedSgke903aService } from '../../../../../sg-ke-shared/services/used-sgke903a.service';
import { ResponseMsgUtils } from '../../../../../sg-ke-shared/util/response-msg-utils';
import { UsedSgke411aService } from '../../services/used-sgke411a.service';
import { UsedSgke412aService } from '../../services/used-sgke412a.service';

@Component({
  selector: 'app-sgke410d',
  templateUrl: './sgke410d.component.html',
  styleUrl: './sgke410d.component.scss'
})
export class Sgke410dComponent implements OnInit, OnDestroy {
  /** メッセージエリア */
  @Output() errorMessageModelArray: Array<SgAriaMessage> = new Array<SgAriaMessage>();

  /** 検索結果リスト */
  searchresultList: Array<Sgke411aResponseSearchresultList> = new Array<Sgke411aResponseSearchresultList>();
  /** sgke401aの検索条件権限リスト */
  cndtAuthorityList: Array<any> = new Array<any>();
  /** 会社地区情報 */
  cmpnyAreaList: Array<Sgke903aResponseCompanyAreaInfo>;
  /** 会社地区初期表示情報 */
  cmpnyAreaInit: Sgke903aResponseInitialhyojiInfo;
  /** 欠損承認対象請求情報PDF */
  lossApprvtargetClaiminfopdf;
  /** コード変換マスタマップ */
  codeConversionMstMap: Map<string, Array<CodeConversionMstDto>> = null;
  /** sgke411aFormGroup */
  sgke411aRequestForm: UntypedFormGroup = this.fb.group({});

  /** SGKE401A_欠損承認依頼・最終承認初期表示API */
  requestSgke401a: Sgke401aRequest;
  /** SGKE404A_欠損承認依頼・最終承認PDF出力API */
  requestSgke404a: Sgke404aRequest;
  /** SGKE411A_欠損判定・承認検索API */
  requestSgke411a: Sgke411aRequest;
  /** SGKE412A_欠損判定・承認登録API */
  requestSgke412a: Sgke412aRequest;

  /** 画面ID */
  private static GAMEN_ID = 'SGKE410D';
  /** 欠損予定ステータス_欠損判定依頼 */
  public LOSSYOTEI_STS_CODE_REQUEST_JUDGMENT = '02';

  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();

  /**
   * コンストラクタ
   * @param {UsedSgke903aService} companyAreaInfoService
   * @param {UsedSgke401aService} initService
   * @param {UsedSgke411aService} searchService
   * @param {UsedSgke412aService} approvalService
   * @param {UsedSgke404aService} outputService
   * @param {CodeConversionMstService} codeConversionMstService
   * @param {ChangeDetectorRef} cd
   * @param {UntypedFormBuilder} fb
   * @param {ResponseMsgUtils} responseMsgUtils
   * @memberof Sgke410dComponent
   */
  constructor(
    private companyAreaInfoService: UsedSgke903aService,
    private initService: UsedSgke401aService,
    public searchService: UsedSgke411aService,
    public approvalService: UsedSgke412aService,
    public outputService: UsedSgke404aService,
    private codeConversionMstService: CodeConversionMstService,
    private cd: ChangeDetectorRef,
    private fb: UntypedFormBuilder,
    private responseMsgUtils: ResponseMsgUtils,
  ) {
  }

  /**
  * 初期処理
  * @memberof Sgke410dComponent
  */
  ngOnInit(): void {

    // コード変換マスタ取得
    this.codeConversionMstService.getCodeConversionMst(['S300620'])
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(data => {
        // ローカルに保存
        this.codeConversionMstMap = data;
      });

    // SGKE401A呼び出し
    this.init();
    this.cd.detectChanges();
    // SGKE903A呼び出し
    this.companyAreaInfo();

  }

  /**
   * 終了処理
   *
   * @memberof Sgke410dComponent
   */
  ngOnDestroy(): void {
    //購読を停止する処理
    this.onDestroy$.next();
  }

  /**
   * SGKE401A_欠損承認依頼・最終承認初期表示API呼び出し
   * @memberof Sgke410dComponent
   */
  init(): void {

    this.requestSgke401a = {
      requestCommon: undefined,
      requestCustomize: {
        apprvGamenFlg: false
      }
    }

    this.initService.doSgke401a(this.requestSgke401a).pipe(takeUntil(this.onDestroy$)).subscribe(
      response => {
        if (response?.responseBusinessArea?.cndtAuthorityList) {
          this.cndtAuthorityList = response?.responseBusinessArea.cndtAuthorityList;
          this.cd.detectChanges();
        }
        // メッセージを表示
        this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
      },
      error => {
      });

  }

  /**
   * SGKE903A_会社地区情報取得API呼出し
   * @memberof Sgke410dComponent
   */
  companyAreaInfo() {
    let requestInfo: Sgke903aRequest = {
      requestCommon: undefined,
      reqBusinessArea: {
        gamenId: Sgke410dComponent.GAMEN_ID
      }
    };

    this.companyAreaInfoService.doSgke903a(requestInfo).pipe(takeUntil(this.onDestroy$)).subscribe(
      response => {
        if (response.responseBusinessArea) {
          this.cmpnyAreaList = response?.responseBusinessArea.companyAreaInformationlist;
          this.cmpnyAreaInit = response?.responseBusinessArea.initialhyojiInfo;
          this.cd.detectChanges();
        }
        // メッセージを表示
        this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
      },
      error => {
      });
  }

  /**
   * 検索ボタン押下時処理
   * @param {boolean} [reSearch=false]
   * @memberof Sgke410dComponent
   */
  onClickSearch(reSearch: boolean = false): void {

    // searchResult初期化
    this.searchresultList.length = 0;
    this.cd.detectChanges();

    // 再検索時はメッセージエリアをクリアしない・リクエストを作らない（初回検索時のリクエストを再利用する）/
    if (!reSearch) {
      this.errorMessageModelArray = new Array<SgAriaMessage>();
      // リクエスト情報をもつオブジェクトを定義
      this.requestSgke411a = this.sgke411aRequestForm.getRawValue() as Sgke411aRequest;
    }
    this.cd.detectChanges();

    // SGKE411A呼び出し
    this.searchService.doSgke411a(this.requestSgke411a).pipe(takeUntil(this.onDestroy$)).subscribe(
      response => {
        if (response?.shtkInfo?.searchresultList) {
          this.searchresultList = response?.shtkInfo.searchresultList;
          this.cd.detectChanges();
        }
        // メッセージを表示
        this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
      },
      error => {
      });
  }

  /**
   * クリアボタン押下時処理
   * @memberof Sgke410dComponent
   */
  onClickClear(): void {
    // エラーメッセージクリア
    this.clearErrorMsg();
    this.searchresultList.length = 0;
  }

  /**
   * 承認ボタン押下時処理
   * @param {Sgke411aResponseSearchresultList[]} selected
   * @memberof Sgke410dComponent
   */
  onClickApproval(selected: Sgke411aResponseSearchresultList[]): void {
    // エラーメッセージクリア
    this.clearErrorMsg();

    // 子オブジェクト生成関数
    let lossyoteiChargeKeylstFunc = function (childRow: Sgke411aResponseLossyoteiChargeKeylst): Sgke412aRequestLossyoteiChargeKeylst {
      return {
        cdtmnyNo: childRow.cdtmnyNo,
        cdtmnyRrkno: childRow.cdtmnyRrkno,
        updateSrno: childRow.updateSrno
      };
    }

    // オブジェクト生成関数
    let lossyoteiChargeInformationlistFunc = function (row: Sgke411aResponseSearchresultList): Sgke412aRequestLossyoteiChargeInformationlist {
      return {
        payCtrNo: row.payCtrNo,
        lossyoteiChargeKeylst: row.lossyoteiChargeKeylst.map(lossyoteiChargeKeylstFunc)
      };
    }

    // 承認リクエスト情報をもつオブジェクトを定義
    this.requestSgke412a = {
      requestCommon: {
        businessDate: null,
        dryRun: false,
        businessReqId: null,
        funcLinkId: null,
        requestCustomize: null,
      },
      lossyoteiChargeInformationlist: selected.map(lossyoteiChargeInformationlistFunc)
    };

    // SGKE412A呼び出し
    this.approvalService.doSgke412a(this.requestSgke412a).pipe(takeUntil(this.onDestroy$)).subscribe(

      response => {
        if (response) {
          // メッセージを表示
          this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
          // 再検索
          this.onClickSearch(true);
        }
      },
      error => {
      }
    );
  }

  /**
   * 出力ボタン押下時処理
   * @param {Sgke411aResponseSearchresultList[]} filtered
   * @memberof Sgke410dComponent
   */
  onClickOutput(filtered: Sgke411aResponseSearchresultList[]): void {
    // エラーメッセージクリア
    this.clearErrorMsg();

    // 子オブジェクト生成関数
    let lossyoteiChargeKeylstFunc = function (childRow: Sgke411aResponseLossyoteiChargeKeylst): Sgke404aRequestLossyoteiChargeKeylst {
      return {
        cdtmnyNo: childRow.cdtmnyNo,
        cdtmnyRrkno: childRow.cdtmnyRrkno,
        updateSrno: childRow.updateSrno
      };
    }

    // オブジェクト生成関数
    let lossInfoListFunc = function (row: Sgke411aResponseSearchresultList): Sgke404aRequestLossInfoList {
      return {
        lossyoteiChargeKeylst: row.lossyoteiChargeKeylst.map(lossyoteiChargeKeylstFunc)
      };
    }

    // pdf出力リクエスト情報をもつオブジェクトを定義
    this.requestSgke404a = {
      requestCommon: {
        businessDate: null,
        dryRun: false,
        businessReqId: null,
        funcLinkId: null,
        requestCustomize: null,
      },
      lossInfoList: filtered.map(lossInfoListFunc),
      lossyoteiStsCode: this.LOSSYOTEI_STS_CODE_REQUEST_JUDGMENT
    };

    // SGKE404A呼び出し
    this.outputService.doSgke404a(this.requestSgke404a).pipe(takeUntil(this.onDestroy$)).subscribe(
      response => {
        // メッセージを表示
        this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
      },
      error => {
      }
    );
  }

  /**
   * エラーメッセージ表示領域をクリア
   * @private
   * @memberof Sgke410dComponent
   */
  public clearErrorMsg() {
    this.errorMessageModelArray.length = 0;
  }

}
